/**
 * OVERRIDE ImageGallery.jsx
 */

import ImageGallery from '../../../../../components/Blocks/Listing/ImageGallery';

export default ImageGallery;